export default __webpack_public_path__ + "static/media/商业生态合作.ade94619.png";